import { useCallback } from 'react';
import { oldTelli } from '~/services';

export enum TableNameTypes {
  BACKOFFICE_VIEW = 'backoffice_visualizacao',
  BACKOFFICE_SIMULATION = 'backoffice_simulacao',
  BACKOFFICE_PERSONAL_DATA = 'backoffice_dados_pessoais',
  BACKOFFICE_PEOPLE_TICKETS = 'backoffice_people_tickets',
  BACKOFFICE_CONFERENCE = 'backoffice_conferencia',
  BACKOFFICE_INTEGRATION = 'backoffice_integracao',
  BACKOFFICE_FORMALIZATION = 'backoffice_formalizacao',
  BACKOFFICE_SIMULATION_FORMALIZATION = 'backoffice_simulacao_formalizacao',
  BACKOFFICE_TABS = 'backoffice_abas',
  BACKOFFICE_FLAG_USER = 'backoffice_flag_user',
  BACKOFFICE_FLUXO_COBRANCA = 'backoffice_fluxo_cobranca',
  BACKOFFICE_FLUXO_QUITACAO = 'backoffice_fluxo_quitacao',
}

export enum FluxoCobrancaScreens {
  COBRANCA_DRAWER_ABERTO = 'cobranca_drawer_aberto',
  COBRANCA_PARCELAS_SELECIONADAS = 'cobranca_parcelas_selecionadas',
  COBRANCA_CONFIRMACAO_DADOS = 'cobranca_confirmacao_dados',
  COBRANCA_PAGAMENTO_GERADO = 'cobranca_pagamento_gerado',
}

export enum FluxoQuitacaoScreens {
  INICIOU_QUITAR_CONTRATO = 'iniciou_quitar_contrato',
  VISUALIZOU_RESUMO_QUITAR_CONTRATO = 'visualizou_resumo_quitar_contrato',
  COPIOU_PIX_QUITAR_CONTRATO = 'copiou_pix_quitar_contrato',
  ERRO_QUITAR_CONTRATO = 'erro_quitar_contrato',
}

const deepToString = (v: any): any => {
  if (v === null || v === undefined) return '';
  if (v instanceof Date) return v.toISOString();
  if (typeof v === 'bigint') return v.toString();

  if (Array.isArray(v)) return v.map(deepToString);
  if (typeof v === 'object') {
    return Object.fromEntries(Object.entries(v).map(([k, val]) => [k, deepToString(val)]));
  }
  return String(v);
};

export const normalizeNullish = <T>(input: T): T => {
  const seen = new WeakSet<object>();

  const walk = (val: any): any => {
    if (val === null || val === undefined) return 'null';
    if (typeof val !== 'object') return val;

    if (seen.has(val as object)) return 'null';
    seen.add(val as object);

    if (Array.isArray(val)) return val.map(walk);

    return Object.fromEntries(Object.keys(val).map((key) => [key, walk(val[key])]));
  };

  return deepToString(walk(input)) as T;
};

export const useTracking = () => {
  const handleTracking = useCallback(async (event: Record<string, any>, tableName: TableNameTypes) => {
    try {
      const eventFormatted = normalizeNullish(event);

      const response = await oldTelli.post('/events', {
        tableName,
        dataType: 'JSON',
        databaseName: 'backoffice-log-events',
        data: [eventFormatted],
      });

      return response;
    } catch (error) {
      console.error('[useTracking] handleTracking error:', error);
      return undefined;
    }
  }, []);

  return { handleTracking };
};
